import {
  RenderFormat,
  ViewerDocumentKind,
  ViewerDownloadTargetKind,
  ViewerOpenContextKind,
  type ContentViewerSession,
  type FileContentRendererConfig,
  type ViewerOpenContext,
  type ViewerUserFileRenderAsset,
} from '@/content-viewer/store/schemas'
import { createViewerSession } from '@/content-viewer/utils/create-viewer-session'
import type { UserFileRead } from '@/uppy-file-upload/schemas'
import { buildUserFileRendererConfig } from './build-user-file-renderer-config'

type UserFileViewerContext = Extract<
  ViewerOpenContext,
  {
    kind:
      | ViewerOpenContextKind.DRIVE_FILE
      | ViewerOpenContextKind.SELECTED_FILE
      | ViewerOpenContextKind.MED_CHRON_REFERENCE
      | ViewerOpenContextKind.MED_CHRON_SOURCE
      | ViewerOpenContextKind.MED_SUMMARY_REFERENCE
      | ViewerOpenContextKind.MED_SUMMARY_SOURCE
      | ViewerOpenContextKind.TIMELINE_REFERENCE
      | ViewerOpenContextKind.TIMELINE_SOURCE
  }
>

type BuildUserFileViewerSessionArgs = {
  userFile: UserFileRead
  renderer?: FileContentRendererConfig
  context: UserFileViewerContext
}

function buildUserFileRenderAsset(renderer: FileContentRendererConfig): ViewerUserFileRenderAsset {
  return {
    format: renderer.format,
  }
}

export function buildUserFileViewerSession(args: BuildUserFileViewerSessionArgs): ContentViewerSession | null {
  const { userFile, context } = args
  const renderer = args.renderer ?? buildUserFileRendererConfig(userFile)
  if (!renderer) return null

  return createViewerSession({
    document: {
      kind: ViewerDocumentKind.USER_FILE,
      userFileId: userFile.id,
      title: userFile.original_filename,
      renderAsset: buildUserFileRenderAsset(renderer),
      downloadTarget: {
        kind: ViewerDownloadTargetKind.USER_FILE_ORIGINAL,
        userFileId: userFile.id,
      },
    },
    context,
    presentation: {
      ...(renderer.format === RenderFormat.PDF
        ? { pdfHighlights: renderer.highlights, startingPage: renderer.startingPage }
        : { markdownHighlights: renderer.highlights ?? undefined }),
    },
  })
}
